import time from 'yoda-core-components/lib/moment/Time';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { DAY, getLocalDateString } from './DateFormatter';
import { COOKIE_PREVIEW_DATE } from '../../common/Constants';

/**
 * getNumberOfDays('Tue Sep 04 00:00:00 CDT 2018', '2018-08-12')
 * @param {[string]} endDate [endDate is mandatory => Ex: "Thu Sep 06 23:59:59 CDT 2018", "2018-09-21"]
 * @param {[string]} startDate [startDate is optional only, if your not sending which is taking the current date}
 */
const getNumberOfDays = (endDate, startDate) => {
    if (!endDate || typeof endDate !== 'string') {
        console.warn('End Date is mandatory');
        return '';
    }
    const date1 = new Date(getLocalDateString(endDate));
    const date2 =
        typeof startDate === 'string' ? new Date(getLocalDateString(startDate)) : new Date();
    const timeMethods = ['getFullYear', 'getMonth', 'getDate'];

    const getYrMonDate = (date) => timeMethods.map((method) => date[method]());

    const numOfDays =
        Math.floor(Date.UTC(...getYrMonDate(date1)) - Date.UTC(...getYrMonDate(date2))) / DAY;

    if (isNaN(numOfDays)) {
        console.warn('Number of days not Number:', numOfDays);
        return '';
    }
    return numOfDays.toString();
};

export function prepareDates(endDate, startDate) {
    const date1 = time(endDate);
    const date2 =
        startDate && (typeof startDate === 'string' || startDate.format)
            ? time(new Date(getLocalDateString(startDate)))
            : time(new Date());

    return {
        formattedEndDate: date1,
        formattedStartDate: date2,
    };
}

export const getDetailedDate = (endDate, startDate) => {
    const { formattedEndDate, formattedStartDate } = prepareDates(endDate, startDate);
    const timeToFormat = time.duration(formattedEndDate.diff(formattedStartDate));

    return {
        hours: Math.floor(timeToFormat.asHours()),
        minutes: timeToFormat.minutes(),
        seconds: timeToFormat.seconds(),
    };
};

export const getNumberOfHours = (endDate, startDate) => {
    const { formattedEndDate, formattedStartDate } = prepareDates(endDate, startDate);
    return Math.floor(formattedEndDate.diff(formattedStartDate) / 36e5);
};

export const getHumanizedDate = (endDate) => time(endDate).format('MMM D');

export default getNumberOfDays;

export const getFormattedPreviewDate = (isPreview) => {
    let formattedPreviewDate = null;
    if (isPreview) {
        const calenderSelectDate = Cookies.load(COOKIE_PREVIEW_DATE);
        let previewDateSelect = null;
        const currectDate = new Date();
        if (calenderSelectDate) {
            const [year, month, day, time] = calenderSelectDate.split(/\.|\s/);
            previewDateSelect = new Date(`${year}-${month}-${day} ${time}`);
        }
        const previewDate = previewDateSelect !== null ? previewDateSelect : currectDate;
        formattedPreviewDate = new Date(getLocalDateString(previewDate)).toString();
    }
    return formattedPreviewDate;
};
